import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { PermissionEnum } from '@app/core/enums/permissions.enum';
import { ValidatorType } from '@app/core/enums/validator-type.enum';
import { AbstractFieldBuilder } from '@app/shared/components/fields/abstract.field';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


@Component({
  selector: 'radiobutton-field-builder',
  templateUrl: './radiobutton-field-builder.component.html',
  styleUrls: ['./radiobutton-field-builder.component.scss'],
  standalone: false
})
export class RadiobuttonFieldBuilderComponent extends AbstractFieldBuilder<FormControl<boolean>> implements OnInit, AfterViewInit {
  protected Permission = PermissionEnum;
  // Display an undefined option if the field is not required
  protected optional = !this.fieldConfig.field.validators.some(validator => validator.type === ValidatorType.REQUIRED);

  public ngOnInit(): void {
    this.form = new FormGroup({
      field: new FormControl(
        this.fieldInitValue,
        this.computeValidators()
      )
    });
    // Initialise the field in the registry
    this.setFieldValue(this.fieldInitValue);
    this.setFieldInitialValue(this.fieldInitValue);
    this.getNextState();
  }

  public ngAfterViewInit(): void {
    this.setupHooks();

    this.form.controls.field.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
      this.setFieldValue(value);
    });
  }

  public formatValue(value: boolean): string {
    if (value === true) {
      return 'LABEL.YES';
    } else if (value === false) {
      return 'LABEL.NO';
    } else {
      return this.appConfig.EMPTY_FIELD_VALUE;
    }
  }

  public cancel(): void {
    this.form.controls.field.setValue(this.getFieldInitialValue());
    super.cancel();
  }
}
